// Stub for optional @sentry/react-native integration (not used in this app).
module.exports = {}
